import { render, staticRenderFns } from "./VideoSliceList.vue?vue&type=template&id=48f3b95a&scoped=true&"
import script from "./VideoSliceList.vue?vue&type=script&lang=js&"
export * from "./VideoSliceList.vue?vue&type=script&lang=js&"
import style0 from "./VideoSliceList.vue?vue&type=style&index=0&id=48f3b95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3b95a",
  null
  
)

export default component.exports